<div class="section section-dark" id="pierwsza-wizyta">
  <div class="container">
    <h2 class="title text-center">Pierwsza wizyta w gabinecie fizjoterapii w Gliwicach</h2>
    <hr class="section-hr reveal fade-width"/>
    <div class="row">
      <div class="col-lg-12">
        <h3 class="description text-justify-lg text-center pb-3">
          <b>Jak przygotować się do pierwszej wizyty u fizjoterapeuty?</b><br/>
        </h3>
        <p class="description text-justify">
          Do pierwszej wizyty u fizjoterapeuty najlepiej przygotować się poprzez wcześniejsze zastanowienie nad
          pytaniami czy problemami kierowanymi do fizjoterapeuty i przygotowanie się na aktywne uczestnictwo w terapii.
          Oto, czego możesz się spodziewać:
        </p>
        <br/>
        <h3 class="description text-justify pb-3">
          <b>Co zabrać na wizytę do fizjoterapeuty?</b>
        </h3>
        <ul class="description text-justify">
          <li>
            <b>wygodny strój</b>, np. koszulka i spodenki, umożliwiające swobodny dostęp do obszaru problematycznego,
          </li>
          <li>
            <b>dokumentację medyczną</b>, w tym wyniki badań obrazowych (RTG, MRI) lub wcześniejsze diagnozy,
          </li>
          <li>
            jeśli nie masz dokumentów, to nie problem – badanie funkcjonalne pozwoli mi ocenić Twój stan zdrowia.
          </li>
        </ul>
        <br/>
        <h3 class="description text-justify pb-3">
          <b>Jak przebiega wizyta u fizjoterapeuty?</b>
        </h3>
        <ol class="description">
          <li>
            <b>Szczegółowy wywiad medyczny</b>
            <span class="md-inline text-justify">
              – omówimy Twoje dolegliwości, styl życia i cele terapeutyczne.
            </span>
            <span class="sm-inline text-justify">
              <br/>Omówimy Twoje dolegliwości, styl życia i cele terapeutyczne.
            </span>
          </li>
          <li>
            <b>Badanie fizjoterapeutyczne</b>
            <span class="md-inline text-justify">
              – obejmuje testy funkcjonalne, ortopedyczne i neurologiczne, dopasowane do Twoich potrzeb.
            </span>
            <span class="sm-inline text-justify">
              <br/>Obejmuje testy funkcjonalne, ortopedyczne i neurologiczne, dopasowane do Twoich potrzeb.
            </span>
          </li>
          <li>
            <b>Plan terapii</b>
            <span class="md-inline text-justify">
               – opracowujemy indywidualny program leczenia i odpowiem na wszystkie Twoje pytania. Jeśli Twój przypadek
              wymaga konsultacji z innym specjalistą, pomogę Ci znaleźć odpowiedniego lekarza.
            </span>
            <span class="sm-inline text-justify">
              <br/>Opracowujemy indywidualny program leczenia i odpowiem na wszystkie Twoje pytania. Jeśli Twój
              przypadek wymaga konsultacji z innym specjalistą, pomogę Ci znaleźć odpowiedniego lekarza.
            </span>
          </li>
        </ol>
        <br/>
        <h3 class="description text-justify-lg text-center pb-3">
          <b>Dlaczego warto wybrać mój gabinet fizjoterapii w Gliwicach?</b>
        </h3>
        <p class="description text-justify mb-4">
          Nie każdy problem bólowy daje się łatwo wyjaśnić jednym objawem czy wynikiem badania. Czasem przyczyna jest
          oczywista, innym razem dolegliwości pojawiają się stopniowo, zmieniają w czasie lub powracają mimo
          wcześniejszego leczenia.
        </p>
        <p class="description text-justify mb-4">
          Nie musisz dokładnie wiedzieć, co jest przyczyną Twoich dolegliwości ani jakiej terapii potrzebujesz. Pierwsza
          wizyta służy temu, aby dobrze poznać problem, ocenić jego charakter i ustalić dalsze postępowanie.
        </p>
        <br/>
      </div>
    </div>
  </div>
</div>
